import PropTypes from "prop-types";
import { Form, InputGroup } from "react-bootstrap";

const InputForm = ({
  id,
  name = "",
  register,
  errors,
  type = "text",
  label = "",
  labelLeft = "",
  labelRight = "",
  helperText = "",
  placeholder = "",
  disabled = false,
  textAlign = "left",
  size = "",
  hidden,
  autoComplete,
  additionalInputParameters = null,
  // onInput,
}) => {
  const hasError = errors[id] !== undefined;
  return (
    <Form.Group controlId={id} style={{ marginBottom: "1rem" }}>
      {label && <Form.Label>{label}</Form.Label>}
      <InputGroup size={size}>
        {labelLeft && (
          <InputGroup.Prepend>
            <InputGroup.Text>{labelLeft}</InputGroup.Text>
          </InputGroup.Prepend>
        )}
        <input
          id={id}
          name={name}
          hidden={hidden}
          className={[
            "form-control",
            size ? `form-control-${size}` : "",
            hasError ? "is-invalid" : "",
          ].join(" ")}
          style={{ textAlign }}
          type={type}
          placeholder={placeholder}
          readOnly={disabled}
          {...register(id)}
          {...additionalInputParameters}
          // onInput={() => onInput()}
          autoComplete={autoComplete}
        />
        {labelRight && (
          <InputGroup.Append>
            <InputGroup.Text>{labelRight}</InputGroup.Text>
          </InputGroup.Append>
        )}
      </InputGroup>

      {hasError && hidden === false && (
        <div className="invalid-feedback" style={{ display: "block" }}>
          {errors[id].message}
        </div>
      )}
      {helperText && <Form.Text muted>{helperText}</Form.Text>}
    </Form.Group>
  );
};

InputForm.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  register: PropTypes.func.isRequired,
  errors: PropTypes.objectOf(PropTypes.object).isRequired,
  label: PropTypes.string,
  labelLeft: PropTypes.string,
  labelRight: PropTypes.string,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
  size: PropTypes.string,
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  textAlign: PropTypes.string,
  hidden: PropTypes.bool,
  onInput: PropTypes.func,
  autoComplete: PropTypes.string,
  additionalInputParameters: PropTypes.array,
};

InputForm.defaultProps = {
  name: "",
  label: "",
  labelLeft: "",
  labelRight: "",
  helperText: "",
  disabled: false,
  size: "",
  placeholder: "",
  textAlign: "left",
  hidden: false,
  onInput: null,
  autoComplete: "on",
  additionalInputParameters: null,
};

export default InputForm;
